import choose5 from './choose5';

import hpten from './hpten';

export default (type, data, ballindex, Vue) => {
  if (type == 'choose5') {
    return choose5(data, ballindex);
  }
  if (type == 'hpten') {
    return hpten(data, ballindex);
  }
};



// WEBPACK FOOTER //
// ./src/pages/Trend/Haomafenbu/columns/index.js